import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { whyPoints } from '../../data/homeContent';

function HomeWhy() {
  const [active, setActive] = useState(0);

  return (
    <section className="home-section home-why">
      <div className="container home-why-inner">
        <div>
          <p className="home-kicker">WHY BRIGHT STUDY</p>
          <h2>Why schools choose this operating system</h2>
          <p className="home-lead">
            Built so campuses can go paperless, keep every report a click away, and run the day without waiting on an engineer.
          </p>
          <div className="home-why-nav">
            {whyPoints.map((item, index) => (
              <button
                key={item.title}
                type="button"
                className={index === active ? 'is-active' : ''}
                onClick={() => setActive(index)}
              >
                {item.title}
              </button>
            ))}
          </div>
        </div>
        <div className="home-why-panel">
          <h3>{whyPoints[active].title}</h3>
          <p>{whyPoints[active].text}</p>
          <Link to="/contact-us/connect-with-us" className="home-btn home-btn-primary">
            Connect with us
          </Link>
        </div>
      </div>
    </section>
  );
}

export default HomeWhy;
